// This file was automatically generated from render.letter.html.
// Please don't edit this file by hand.

goog.provide('el8.template.passport.render.letter');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.passport.SubPane');
goog.require('el8.template.ptdata.letters.attachments');
goog.require('el8.template.shared.commentReplyForm');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.render.letter.header = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.passport.SubPane.backButton(null, output);
  output.append((opt_data.isProcessed) ? '<button class="download-' + ((opt_data.isWithArchive) ? 'zip' : 'pdf') + '-trigger el8HeaderButton el8ProfileButton fr"><span class="el8DownloadIcon"></span>Download All</button>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.render.letter.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h1 class="el8ScreenReaderOnly">Letter Contents</h1><div class="el8LetterContainer">', (opt_data.letter.subject) ? '<h2 class="el8LetterSubject mb1em">Re: ' + soy.$$escapeHtml(opt_data.letter.subject) + '</h2>' : '', '<div class="el8LetterTop"><div class="el8LetterTime"><p>', (soy.$$escapeHtml(opt_data.letter.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.letter.documentDate)) : ''), ' ', (soy.$$escapeHtml(opt_data.letter.documentDate)? el8.service.tz.soyTime(soy.$$escapeHtml(opt_data.letter.documentDate)) : ''), '</p></div>', (opt_data.letter.signUserType == 'Patient') ? '<p><span class="el8Bold">Me</span> to <span class="el8Bold">' + soy.$$escapeHtml(opt_data.letter.displayTo) + '</span>:</p>' : (opt_data.letter.signUserType == 'Unknown') ? '<p><span class="el8Bold">Unknown</span> to <span class="el8Bold">' + soy.$$escapeHtml(opt_data.letter.displayTo) + '</span>:</p>' : '<p><span class="el8Bold">' + soy.$$escapeHtml(opt_data.letter.signUserName) + '</span> to <span class="el8Bold">Me</span>:</p>', '</div><p class="el8Preserve">', soy.$$escapeHtml(opt_data.letter.body), '</p><ol class="attachment-section el8AttachmentResults">');
  el8.template.passport.render.letter.attachmentSection(opt_data.letter, output);
  output.append('</ol></div>');
  if (! opt_data.letter.closeTime || opt_data.letter.comments.length) {
    el8.template.passport.render.letter.commentSection(soy.$$augmentData(opt_data.letter, {primaryPhysicianLastName: opt_data.primaryPhysicianLastName, primaryPhysicianPhone: opt_data.primaryPhysicianPhone}), output);
  }
  output.append('<div class="el8Push"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.render.letter.attachmentSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var aList1196 = opt_data.attachments;
  var aListLen1196 = aList1196.length;
  for (var aIndex1196 = 0; aIndex1196 < aListLen1196; aIndex1196++) {
    var aData1196 = aList1196[aIndex1196];
    if (aData1196.attachmentType == 'Entity' || aData1196.attachmentType == 'CompMedsList' || aData1196.attachmentType.endswith('Chart')) {
      output.append('<li class="attachment-detail" tabindex="0" data-id=', (aData1196.entityId) ? soy.$$escapeHtml(aData1196.entityId) : soy.$$escapeHtml(aData1196.attachmentType), '><img class="fl el8PaperClip" src="/static/images/transparent_16x16.png" alt="Attachment Icon" />');
      el8.template.ptdata.letters.attachments.savedAttachmentSummary(soy.$$augmentData(aData1196, {noAttachmentLinks: true}), output);
      output.append('<div class="el8IconOpenArrow el8IconOpenArrowPositionAttachment"></div></li>');
    }
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.render.letter.commentSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="letter-comments el8ResponsesSection"><p class="el8ResponsesHeader">Responses</p>');
  var cList1212 = opt_data.comments;
  var cListLen1212 = cList1212.length;
  for (var cIndex1212 = 0; cIndex1212 < cListLen1212; cIndex1212++) {
    var cData1212 = cList1212[cIndex1212];
    output.append('<div class="el8ResponsesContainer clearfix', (cData1212.fromPracticeId != el8Globals.PRACTICE_ID && ! cData1212.readTime) ? ' el8Highlight' : '', '"><span class="el8ResponseDate">', (soy.$$escapeHtml(cData1212.createDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(cData1212.createDate)) : ''), '</span><p class="mb5"><span class="el8ResponseAuthor">', soy.$$escapeHtml(cData1212.authorName), ':</span></p><p class="el8Preserve el8ResponseBody"><span class="el8IconResponses el8IconResponsesPositionLetter"></span>', soy.$$escapeHtml(cData1212.message), '</p></div>');
  }
  el8.template.shared.commentReplyForm.replyTrigger(soy.$$augmentData(opt_data, {primaryPhysicianPhone: opt_data.primaryPhysicianPhone, primaryPhysicianLastName: opt_data.primaryPhysicianLastName}), output);
  output.append((! opt_data.closeTime) ? '<div class="el8ResponseDisclaimer">Passport is for non-urgent communication only. <strong>If this is an emergency, call 911 now.</strong> If your issue is not an emergency, but requires immediate attention, please call our office' + ((opt_data.primaryPhysicianPhone) ? ' at ' + soy.$$escapeHtml(opt_data.primaryPhysicianPhone) : '') + '.</div>' : '', '</div>');
  if (!opt_sb) return output.toString();
};
